module.exports = __webpack_public_path__ + "img/img-13.23fe4b5c.jpeg";